import { CognitoUser } from '@aws-amplify/auth';
import { Logger, LogType } from '@hitiq/logger';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { Auth } from 'aws-amplify';

type CurrentAuthenticatedUserThunkPayload = {
  logger: Logger;
};

export const currentAuthenticatedUserThunk = createAsyncThunk<
  CognitoUser,
  CurrentAuthenticatedUserThunkPayload
>('auth/currentUserThunk', async (payload, thunkApi) => {
  try {
    return await Auth.currentAuthenticatedUser();
  } catch (error) {
    payload.logger.log(
      LogType.debug,
      `Auth: currentAuthenticatedUserThunk error: ${error} (this throws and error if no user is cached so is most of the time not an error just no current logged in user)`,
    );
    // TODO: figure out why error is shown in browser when thunk throws
    // reject so we can set user to null (meaning explicitly invalid, not just unset/undefined)
    return thunkApi.rejectWithValue({
      message: error,
    });
  }
});
